<template>
  <div class="page">
    <SiteHero
      pageTitle="Locations"
      pageDescription="Discover our training facilities and find the perfect place to start your journey."
    />

    <div class="page-content">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="grid grid-cols-1 gap-8">
          <div v-for="location in locationsData" :key="location.name">
            <TrainingGround
              :location="location"
              :showScheduleLink="true"
            />
          </div>
        </div>
      </div>

      <Testimonials />
    </div>

    <SiteFooter />
  </div>
</template>

<script>
  import SiteFooter from '../components/Footer/SiteFooter.vue';
  import SiteHero from '../components/Hero/SiteHero.vue';
  import TrainingGround from '../components/Location/TrainingGround.vue';
  import Testimonials from '../components/HomePage/Testimonials.vue';
  import locationsData from '../data/locations.json';
  import '../assets/styles/page.css';

  export default {
    name: 'LocationsPage',
    components: {
      SiteFooter,
      SiteHero,
      TrainingGround,
      Testimonials
    },
    data() {
      return {
        locationsData: locationsData.locations
      }
    }
  };
</script>
